var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { router } from "@/Router";
import { GlobalContext } from "@/contexts/GlobalContext";
import { getJobBoardTheme } from "@/theme/JobBoardTheme";
import { transformThemePaletteToJobBoardTheme } from "@/theme/utils";
import { ChakraProvider, EnvironmentProvider } from "@chakra-ui/react";
import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import { config } from "@fortawesome/fontawesome-svg-core";
// @ts-expect-error - FontAwesome CSS import without proper TypeScript declarations
import styles from "@fortawesome/fontawesome-svg-core/styles.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
export function render(rootElement, properties, theme, countryConfig, applyFlowParameters, filters) {
    var root = ReactDOM.createRoot(rootElement);
    var ownerDocument = rootElement.ownerDocument;
    var rootNode = rootElement.getRootNode();
    var hasShadowRoot = isShadowRoot(rootNode, ownerDocument);
    var jobBoardTheme = "primaryContent" in theme
        ? transformThemePaletteToJobBoardTheme(theme)
        : theme;
    var fullTheme = getJobBoardTheme(jobBoardTheme, hasShadowRoot ? ":host" : undefined);
    var cache = createCache({
        key: "css",
        container: rootElement,
    });
    root.render(_jsx(React.StrictMode, { children: _jsx(EnvironmentProvider, __assign({ value: function () { return (hasShadowRoot ? rootNode : ownerDocument); } }, { children: _jsx(CacheProvider, __assign({ value: cache }, { children: _jsx(ChakraProvider, __assign({ value: fullTheme }, { children: _jsx(GlobalContext.Provider, __assign({ value: { properties: properties, countryConfig: countryConfig, applyFlowParameters: applyFlowParameters } }, { children: _jsx(RouterProvider, { router: router(filters) }) })) })) })) })) }));
    configureFontAwesomeCss(rootElement);
    return root;
}
function configureFontAwesomeCss(rootElement) {
    var ownerDocument = rootElement.ownerDocument;
    var rootNode = rootElement.getRootNode();
    if (isShadowRoot(rootNode, ownerDocument)) {
        // If the root element is a shadow DOM, prepend the style tag to the shadow root
        config.autoAddCss = false;
        var styleTag = ownerDocument.createElement("style");
        styleTag.innerHTML = styles;
        rootNode.prepend(styleTag);
    }
}
function isShadowRoot(rootNode, ownerDocument) {
    var ownerWindow = ownerDocument.defaultView;
    return ownerWindow !== null && rootNode instanceof ownerWindow.ShadowRoot;
}
